import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
const DashboardDocumentIndicators = ({ amount }) => {
    const [activeDocument, setActiveDocument] = useState(1);
    const indicators = [];
    for (let i = 1; i <= amount; i++) {
        indicators.push(i);
    }
    useEffect(() => {
        const animationObserver = new window.IntersectionObserver((entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    const id = /section-(\d*)/g.exec(entry.target.id);
                    setActiveDocument(Number(id[1]));
                }
            }
        }, { threshold: 1 });
        setTimeout(() => {
            indicators.forEach(indicator => {
                animationObserver.observe(document.getElementById(`section-${indicator}`));
            });
        }, 0);
    }, []);
    return (_jsx("div", { children: indicators.map(indicator => (_jsx("li", { children: _jsx("a", Object.assign({ className: `inline-block pb-1 ${activeDocument === indicator ? 'text-dark-teal font-semibold' : 'dark-gray font-normal'}`, href: `#section-${indicator}` }, { children: indicator })) }, indicator))) }));
};
DashboardDocumentIndicators.propTypes = { amount: PropTypes.number };
export default DashboardDocumentIndicators;
